import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5b72c766")

_pushScopeId("data-v-5b72c766")
const _hoisted_1 = { class: "d-flex flex-column mb-5 fv-row" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex align-items-center fs-6 fw-bold mb-2"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      (_ctx.label)
        ? (_openBlock(), _createBlock("label", _hoisted_2, [
            _createVNode("span", {
              class: { required: _ctx.required }
            }, _toDisplayString(_ctx.label), 3)
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_el_form_item, {
        prop: _ctx.name,
        rules: [{ required: _ctx.required, message: _ctx.translate(_ctx.requiredMsg) }],
        class: "input-item additional"
      }, {
        default: _withId(() => [
          _createVNode(_component_el_select, {
            class: "select-item",
            modelValue: _ctx.selectedValue,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedValue = $event)),
            value: _ctx.value,
            placeholder: _ctx.translate(_ctx.placeholder),
            onChange: _ctx.updateValue,
            onFocus: _ctx.focusHandler,
            multiple: _ctx.multiple,
            filterable: _ctx.filterable,
            remote: _ctx.remote,
            "reserve-keyword": _ctx.reserveKeyword,
            clearable: _ctx.clearable,
            disabled: _ctx.disabled,
            "multiple-limit": _ctx.multipleLimit,
            "allow-create": _ctx.allowCreateNew,
            "default-first-option": _ctx.allowCreateNew
          }, {
            default: _withId(() => [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectData, (single) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: single.value,
                  label: _ctx.$t(single.label),
                  value: single.value
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue", "value", "placeholder", "onChange", "onFocus", "multiple", "filterable", "remote", "reserve-keyword", "clearable", "disabled", "multiple-limit", "allow-create", "default-first-option"])
        ]),
        _: 1
      }, 8, ["prop", "rules"])
    ])
  ]))
})